export default __webpack_public_path__ + "static/media/Globe Life.2f7e1ff0.svg";